/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytUlicTo } from '../../models/teryt-ulic-to';

export interface ApiWebTerytUliceGet$Params {
  date?: LocalDate;
  pow?: string;
  q?: string;
  simc?: string;
  woj?: string;
}

export function apiWebTerytUliceGet(http: HttpClient, rootUrl: string, params?: ApiWebTerytUliceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytUlicTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytUliceGet.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('pow', params.pow, {});
    rb.query('q', params.q, {});
    rb.query('simc', params.simc, {});
    rb.query('woj', params.woj, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TerytUlicTo>>;
    })
  );
}

apiWebTerytUliceGet.PATH = '/api/web/teryt/ulice';
